import script from "./EventSearchLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./EventSearchLayout.vue?vue&type=script&setup=true&lang=js"

import "./EventSearchLayout.vue?vue&type=style&index=0&id=3b1ae543&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b1ae543"]])

export default __exports__